import { jsx, jsxs } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { buildDataAttributes } from "../buildDataAttributes.mjs";
import { MaxLines } from "../MaxLines/MaxLines.mjs";
import { alignToFlexAlign } from "../../../utils/align.mjs";
import dedent from "dedent";
import { descenderCropFixForWebkitBox } from "../MaxLines/MaxLines.css.mjs";
const Typography = ({
  id,
  component = "span",
  className,
  align,
  truncate = false,
  maxLines,
  icon,
  data,
  children,
  ...restProps
}) => {
  const lines = truncate ? 1 : maxLines;
  const isTruncated = typeof lines === "number";
  const contents = isTruncated ? /* @__PURE__ */ jsx(MaxLines, { lines, children }) : children;
  if (process.env.NODE_ENV !== "production") {
    if (truncate) {
      console.warn(
        dedent`
          The "truncate" prop has been deprecated and will be removed in a future version. Use "maxLines" instead.
             <Text
            %c-   truncate
            %c+   maxLines={1}
             %c/>
        `,
        "color: red",
        "color: green",
        "color: inherit"
      );
    }
  }
  return /* @__PURE__ */ jsx(
    Box,
    {
      id,
      display: "block",
      component,
      textAlign: align,
      className: [
        className,
        isTruncated ? descenderCropFixForWebkitBox : void 0
      ],
      minWidth: isTruncated ? 0 : void 0,
      ...buildDataAttributes({ data, validateRestProps: restProps }),
      children: icon ? /* @__PURE__ */ jsxs(
        Box,
        {
          component: "span",
          display: "flex",
          justifyContent: alignToFlexAlign(align),
          children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                component: "span",
                display: "block",
                paddingRight: "xsmall",
                flexGrow: 0,
                flexShrink: 0,
                minWidth: 0,
                textAlign: align,
                children: icon
              }
            ),
            /* @__PURE__ */ jsx(Box, { component: "span", display: "block", minWidth: 0, children: contents })
          ]
        }
      ) : contents
    }
  );
};
export {
  Typography
};
